import type { RenderCard, RenderPresentation } from '../../../insightRenderPresentation'
import { Note } from '../InsightsBlocks'
import { MetricCard } from './MetricCard'
import { PopulationStepsCard } from './PopulationStepsCard'
import { InsightCardHeader, InsightCardHelpContent } from './InsightCardHeader'

function Card({ card }: { card: RenderCard }) {
  switch (card.kind) {
    case 'render-error':
      return <s-banner tone="critical">{card.message}</s-banner>
    case 'metric':
      return <MetricCard card={card} />
    case 'population-steps':
      return <PopulationStepsCard card={card} />
  }
}

/** Original generic card renderer, narrowed to the visual kinds used by the restored answer. */
export function InsightCardRenderer({ presentation }: { presentation: RenderPresentation }) {
  if (presentation.unsupported) return <s-banner tone="critical">This insight presentation is not supported.</s-banner>
  return (
    <s-stack gap="base" data-insight-presentation>
      {presentation.sections.map((section) => {
        const hasPopulationSteps = section.cards.some((card) => card.kind === 'population-steps')
        let graphic = null
        let footer = null
        if (hasPopulationSteps) {
          graphic = <s-icon slot="graphic" type="chart-funnel" />
          footer = <Note>{section.help.how}</Note>
        }
        return (
          <s-section key={section.id} heading={section.title}>
            {graphic}
            <InsightCardHeader title={section.title} help={section.help} />
            <s-stack gap="base">
              {section.cards.map((card, index) => {
                let help = null
                if ('help' in card && card.help) help = <InsightCardHelpContent help={card.help} />
                return (
                  <s-stack key={index} gap="small" data-insight-card-kind={card.kind}>
                    <Card card={card} />
                    {help}
                  </s-stack>
                )
              })}
              {footer}
            </s-stack>
          </s-section>
        )
      })}
    </s-stack>
  )
}
